import React from "react";
import { Link } from "react-router-dom";
import { useGlobalContext } from "../../context/GlobalContext";
import notFoundImage from "../../assets/images/not_found.png"

const NotFound: React.FC = () => {
  const { user } = useGlobalContext();
  return (
    <div className="flex flex-col items-center justify-center h-screen text-gray-800">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-primary mb-4">404</h1>
        <h2 className="text-2xl font-medium mb-2">Page Not Found</h2>
        <p className="text-lg mb-6">
          Oops! The page you are looking for doesn't exist or has been moved.
        </p>
        {user.token && (
          <Link
            to="/"
            className="px-6 py-3 bg-primary text-white font-semibold rounded-lg shadow hover:bg-secondary transition"
          >
            Go Back to Dashboard
          </Link>
        )}
      </div>
      <div className="mt-8">
        <img
          src={notFoundImage}
          alt="404 Not Found"
          className="max-w-xs w-[250px] md:max-w-md mx-auto"
        />
      </div>
    </div>
  );
};

export default NotFound;
